import React, { useMemo } from 'react'
import Seo from '../Seo'

const env = (typeof process !== 'undefined' && process.env) || {}

const DEFAULTS = {
  embedUrl: 'https://app.leanit101.com/benjamin',
  embedToken:
    'eyJvcmdhbml6YXRpb25JZCI6MzksImFnZW50U2x1ZyI6ImF2YW5jYXItc2FsZXMtYXNzaXN0YW50IiwidGVuYW50U2x1ZyI6ImF2YW4tYXItY3ItZGl0b3MtaW1lZGlhdG9zIiwiYXNzaXN0YW50TmFtZSI6IkNhbGViIiwibWV0YWRhdGEiOnsiY2hhbm5lbERlZmF1bHQiOiJ3ZWJfZW1iZWQifX0.4a68c80d7b3eafcb83615761e182e767f78ebe0aaa891d1686bb04340a1f949b',
  agentSlug: 'avancar-sales-assistant',
  tenantSlug: 'avan-ar-cr-ditos-imediatos',
  organizationId: '39',
  assistantName: 'Caleb',
  channel: 'web_embed',
  utmSource: 'leanit101.com',
  utmCampaign: 'avancar-sales-poc',
}

const AvancarSalesPage = () => {
  const queryParams = useMemo(() => {
    if (typeof window === 'undefined') return new URLSearchParams('')
    return new URLSearchParams(window.location.search || '')
  }, [])

  const embedToken =
    queryParams.get('token') ||
    env.REACT_APP_AVANCAR_SALES_EMBED_TOKEN ||
    DEFAULTS.embedToken

  const agentSlug =
    queryParams.get('agentSlug') ||
    env.REACT_APP_AVANCAR_SALES_AGENT_SLUG ||
    DEFAULTS.agentSlug

  const resolvedTenant =
    queryParams.get('tenantSlug') ||
    env.REACT_APP_AVANCAR_SALES_TENANT_SLUG ||
    DEFAULTS.tenantSlug
  const tenantSlug = resolvedTenant.toString().trim().toLowerCase()

  const orgId =
    queryParams.get('organizationId') ||
    env.REACT_APP_AVANCAR_SALES_ORGANIZATION_ID ||
    DEFAULTS.organizationId

  const assistantName =
    queryParams.get('assistantName') ||
    env.REACT_APP_AVANCAR_SALES_ASSISTANT_NAME ||
    DEFAULTS.assistantName

  const channel = queryParams.get('channel') || DEFAULTS.channel
  const utmSource = queryParams.get('utm_source') || DEFAULTS.utmSource
  const utmCampaign = queryParams.get('utm_campaign') || DEFAULTS.utmCampaign

  const iframeSrc = useMemo(() => {
    const params = new URLSearchParams()
    if (embedToken) {
      params.set('token', embedToken)
    }
    params.set('agentSlug', agentSlug)
    params.set('tenantSlug', tenantSlug)
    params.set('organizationId', orgId)
    params.set('assistantName', assistantName)
    params.set('channel', channel)
    params.set('locale', 'pt-BR')
    if (utmSource) params.set('utm_source', utmSource)
    if (utmCampaign) params.set('utm_campaign', utmCampaign)
    params.set('meta.source', 'avancar-sales-poc')
    params.set('meta.partner', 'avancar-creditos-imediatos')

    const baseUrl = env.REACT_APP_AVANCAR_SALES_EMBED_URL || DEFAULTS.embedUrl
    return `${baseUrl}?${params.toString()}`
  }, [
    agentSlug,
    assistantName,
    channel,
    embedToken,
    orgId,
    tenantSlug,
    utmCampaign,
    utmSource,
  ])

  return (
    <section className="relative flex flex-col w-full min-h-screen overflow-hidden bg-[#060812] text-white">
      <Seo
        title="Avançar Créditos Imediatos | Caleb"
        description="POC privada para validação do agente comercial da Avançar Créditos Imediatos."
        path="/avancar-sales"
        noindex
      />
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-b from-[#0b1020] via-[#060812] to-[#060812]" />
        <div
          className="absolute -top-24 left-[18%] w-[560px] h-[560px] rounded-full opacity-30"
          style={{
            background:
              'radial-gradient(50% 50% at 50% 50%, rgba(201,211,58,0.34) 0%, rgba(201,211,58,0) 66%)',
            filter: 'blur(54px)',
          }}
        />
        <div
          className="absolute bottom-[-220px] right-[-100px] w-[560px] h-[560px] rounded-full opacity-20"
          style={{
            background:
              'radial-gradient(50% 50% at 50% 50%, rgba(248,129,22,0.34) 0%, rgba(248,129,22,0) 62%)',
            filter: 'blur(44px)',
          }}
        />
        <div
          className="absolute inset-0 opacity-[0.07]"
          style={{
            backgroundImage:
              'linear-gradient(to right, rgba(255,255,255,0.06) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.06) 1px, transparent 1px)',
            backgroundSize: '28px 28px',
          }}
        />
      </div>

      <div className="w-full max-w-6xl mx-auto px-4 py-12 md:py-16 space-y-8">
        <header className="text-center space-y-4">
          <p className="text-xs uppercase tracking-[0.4em] text-lime-200/70">
            Avançar Créditos Imediatos
          </p>
          <h1 className="text-3xl md:text-5xl font-semibold">
            Caleb • Pré-triagem comercial
          </h1>
          <p className="max-w-3xl mx-auto text-base md:text-lg text-slate-200">
            Página de POC para validar o agente que faz a triagem inicial de
            leads interessados em crédito para comércio. O foco aqui é tom
            humano, objetividade e passagem correta para o time da Avançar.
          </p>
        </header>

        <div className="grid gap-6 lg:grid-cols-[1.15fr_minmax(320px,0.85fr)]">
          <div className="w-full bg-slate-900/55 border border-lime-200/10 rounded-[28px] shadow-2xl overflow-hidden">
            <div className="px-5 py-4 border-b border-white/8">
              <div className="text-[11px] uppercase tracking-[0.34em] text-lime-200/65">
                Conversa ao vivo
              </div>
              <div className="mt-2 text-sm text-slate-300">
                Fluxo em português, com foco em intenção, valor, tipo de comércio,
                operação atual e crédito em andamento.
              </div>
            </div>
            <div className="relative w-full h-[560px] md:h-[660px]">
              <iframe
                title="Caleb — Avançar Créditos Imediatos"
                src={iframeSrc}
                allow="clipboard-read; clipboard-write"
                className="absolute inset-0 w-full h-full"
                style={{ background: 'transparent' }}
              />
            </div>
          </div>

          <div className="grid gap-4 content-start">
            <div className="bg-white/5 border border-white/10 rounded-2xl p-5 backdrop-blur-sm">
              <div className="text-[11px] uppercase tracking-[0.3em] text-lime-200/70">
                Perfil do agente
              </div>
              <h2 className="mt-3 text-xl font-semibold">Humano, direto e confiável</h2>
              <p className="mt-3 text-sm text-slate-200 leading-6">
                O Caleb foi configurado para soar como alguém do time comercial,
                sem prometer aprovação, taxa, prazo ou liberação. Ele faz apenas
                a triagem inicial e prepara o caso para continuidade humana.
              </p>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-2xl p-5 backdrop-blur-sm">
              <div className="text-[11px] uppercase tracking-[0.3em] text-lime-200/70">
                O que validar
              </div>
              <ul className="mt-3 space-y-3 text-sm text-slate-200 leading-6">
                <li>Se o tom parece de uma pessoa real do time da Avançar.</li>
                <li>Se ele coleta as informações essenciais com poucas mensagens.</li>
                <li>Se evita promessas e mantém a conversa dentro do papel comercial.</li>
              </ul>
            </div>

            <div className="bg-[#0d1322] border border-cyan-400/20 rounded-2xl p-5">
              <div className="text-[11px] uppercase tracking-[0.3em] text-cyan-200/75">
                Compartilhamento
              </div>
              <p className="mt-3 text-sm text-slate-200 leading-6">
                Use este link com o cliente para validação da POC:
              </p>
              <code className="mt-3 block text-xs md:text-sm break-all text-amber-200">
                https://leanit101.com/avancar-sales
              </code>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-2xl p-5 backdrop-blur-sm">
              <div className="text-[11px] uppercase tracking-[0.3em] text-lime-200/70">
                Rastreio
              </div>
              <p className="mt-3 text-sm text-slate-200 leading-6">
                Eventos desta página chegam com <strong>organizationId 39</strong>,
                locale <strong>pt-BR</strong> e metadados específicos da POC da
                Avançar.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AvancarSalesPage
